import Registry from '../registry'
import React from 'react'
import CheckboxGroup from '../components/fields/CheckboxGroup'
import t from 'tcomb-form'
import select from './select'

const checkbox = {
  name: 'Checkbox',
  group: 'Choice',
  options: {
    choices: {
      label: 'Choices',
      help: 'One choice per line.',
      required: true,
      type: 'list',
      of: {type: 'string'}
    },
    default_value: {
      label: 'Default choice',
      type: 'string'
    }
  },
  schema: part => ({
    ...select.schema(part),
    type: 'list',
    of: {
      type: 'string',
      allowedValues: select.choices(part.choices)
    },
    factory: t.form.Select,
    component: ({ options, value, onChange }) =>
      <CheckboxGroup options={options} value={value} onChange={onChange} />
  })
}

Registry.register('checkbox', checkbox)

export default checkbox



// WEBPACK FOOTER //
// ./app/parts/checkbox.js